import React from 'react';
import { X, Menu, Settings } from 'lucide-react';
import { getThemeClass } from '../../../utils/theme';

/**
 * AdminHeader - Panel header with title and controls
 * 
 * @param {Object} props
 * @param {Function} props.onClose - Close panel callback
 * @param {Function} props.onToggleMobileNav - Toggle mobile navigation
 * @param {boolean} props.isMobileNavOpen - Mobile nav state
 * @param {string} props.theme - Theme name ('dark' | 'light')
 */
const AdminHeader = ({ 
  onClose, 
  onToggleMobileNav, 
  isMobileNavOpen,
  theme = 'dark' 
}) => {
  return (
    <div 
      className={`
        flex-none flex items-center justify-between 
        px-4 py-3 border-b
        ${getThemeClass(theme, 'panel')}
        ${getThemeClass(theme, 'border')}
      `}
    >
      {/* Left side: Mobile menu + Title */}
      <div className="flex items-center gap-3">
        {/* Mobile hamburger - only visible on small screens */}
        <button
          onClick={onToggleMobileNav}
          className={`
            lg:hidden p-2 rounded-lg transition-colors
            ${getThemeClass(theme, 'text.secondary')}
            hover:bg-slate-700
          `}
          aria-label={isMobileNavOpen ? 'Close navigation' : 'Open navigation'}
          aria-expanded={isMobileNavOpen}
        >
          <Menu size={20} />
        </button>

        {/* Title */}
        <div className="flex items-center gap-2">
          <Settings size={20} className="text-blue-400" />
          <h1 className={`text-lg font-semibold ${getThemeClass(theme, 'text.primary')}`}>
            Site Settings
          </h1>
        </div>
      </div>

      {/* Right side: Close button */}
      <button
        onClick={onClose}
        className={`
          p-2 rounded-lg transition-colors
          ${getThemeClass(theme, 'text.secondary')}
          hover:bg-slate-700
        `}
        aria-label="Close admin panel"
      >
        <X size={20} />
      </button>
    </div>
  );
};

export default AdminHeader;



